export const LoanInfoHeaderItemTestIds = {
  getLinkId: id => `loan-info-header-item.link-${id}`,
};
